/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { EnterpriseLearnerInsights_MetricTimeFrame as MetricTimeframe } from '__generated__/graphql-types';

import { useParams } from 'js/lib/useRouter';

import { Grid, SelectField, SelectOption, Typography2 } from '@coursera/cds-core';
import { CalendarIcon } from '@coursera/cds-icons';
import { useTracker } from '@coursera/event-pulse/react';

import _t from 'i18n!nls/enterprise-admin-home';

type Props = {
  selectedTimeFrame: MetricTimeframe;
  onSelectChipStub: (timeFrame: MetricTimeframe) => void;
  selectedTimePeriodLabel: string;
};

export const TimePeriodSelector = (props: Props): React.ReactElement => {
  const { selectedTimeFrame, onSelectChipStub, selectedTimePeriodLabel } = props;
  const { thirdPartySlug } = useParams();
  const track = useTracker();
  return (
    <Grid
      item
      css={css`
        display: flex;
        align-items: center;
        gap: var(--cds-spacing-150);
      `}
    >
      <SelectField
        aria-label={_t('Time period')}
        value={selectedTimeFrame}
        onChange={(event) => {
          const value = event.target.value as MetricTimeframe;
          onSelectChipStub(value);
          track('change_enterprise_admin_home_page_time_period', {
            enterpriseAdminHomeTimePeriod: (
              {
                [MetricTimeframe.ThirtyDays]: 'last_30_days',
                [MetricTimeframe.SixtyDays]: 'last_60_days',
                [MetricTimeframe.NinetyDays]: 'last_90_days',
              } as const
            )[value],
            enterprise: {
              organizationSlug: thirdPartySlug,
            },
          });
        }}
      >
        <SelectOption value={MetricTimeframe.ThirtyDays}>{_t('Last 30 days')}</SelectOption>
        <SelectOption value={MetricTimeframe.SixtyDays}>{_t('Last 60 days')}</SelectOption>
        <SelectOption value={MetricTimeframe.NinetyDays}>{_t('Last 90 days')}</SelectOption>
      </SelectField>
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: var(--cds-spacing-100);
        `}
      >
        <CalendarIcon color="support" />
        <Typography2 component="span" variant="actionSecondary" color="supportText">
          {selectedTimePeriodLabel}
        </Typography2>
      </div>
    </Grid>
  );
};

export default TimePeriodSelector;
